/**
 * Pure client-side auth validation helpers.
 * Every function returns a Dutch error message or null when valid.
 * Server-side policy (RLS, rate limits) remains the source of truth; these
 * checks only give fast, honest inline feedback.
 */

/** Pragmatic email check: one @, no spaces, a dot in the domain part. */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export const PASSWORD_MIN_LENGTH = 8

export function validateEmail(email: string): string | null {
  const value = email.trim()
  if (value.length === 0) return 'Vul je e-mailadres in.'
  if (!EMAIL_RE.test(value)) return 'Dit e-mailadres lijkt niet te kloppen. Controleer het nog even.'
  return null
}

/**
 * Password policy (contract: min 8 chars, at least one letter and one number).
 */
export function validatePassword(password: string): string | null {
  if (password.length === 0) return 'Kies een wachtwoord.'
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Je wachtwoord moet minstens ${PASSWORD_MIN_LENGTH} tekens lang zijn.`
  }
  if (!/[A-Za-zÀ-ÿ]/.test(password)) return 'Je wachtwoord moet minstens één letter bevatten.'
  if (!/\d/.test(password)) return 'Je wachtwoord moet minstens één cijfer bevatten.'
  return null
}

/** Hint shown under password fields, matching validatePassword exactly. */
export const PASSWORD_POLICY_HINT = `Minstens ${PASSWORD_MIN_LENGTH} tekens, met minstens één letter en één cijfer.`

export function validatePasswordConfirm(password: string, confirm: string): string | null {
  if (confirm.length === 0) return 'Herhaal je wachtwoord.'
  if (password !== confirm) return 'De wachtwoorden zijn niet hetzelfde.'
  return null
}

export function validateDisplayName(name: string): string | null {
  const value = name.trim()
  if (value.length === 0) return 'Vul je naam in.'
  if (value.length > 60) return 'Je naam mag maximaal 60 tekens lang zijn.'
  return null
}
